import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { usePostRequestAction } from "../../hooks";

export const CancelPublishButton = ({ cancelPublishAction, isLoading }) => {
  const [open, setOpen] = useState(false);

  const handleCancelPublish = async () => {
    await cancelPublishAction();
    setOpen(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <Button size="small" fluid onClick={handleClick}>
        Cancel Publish Request
      </Button>

      <Modal open={open} onClose={() => setOpen(false)} size="small">
        <Modal.Header>Confirm Cancel Publish Request</Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to cancel publish request of this draft?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            color="red"
            onClick={handleCancelPublish}
            loading={isLoading}
            disabled={isLoading}
          >
            Confirm Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

CancelPublishButton.propTypes = {
  cancelPublishAction: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
